import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
const Title = () => {
    const { t } = useTranslation();
    return (_jsx("div", { className: "mb-150 d-flex align-items-center justify-content-between", children: _jsx("h4", { className: "m-0 text-uppercase d-inline-block", children: t('General.Settings_') }) }));
};
export default Title;
